import api from "@/lib/api";

export const MAX_UPLOAD = 500 * 1024 * 1024;
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

async function withRetry(fn, tries = 4) {
  for (let i = 0; ; i++) {
    try { return await fn(); } catch (err) {
      const s = err.response?.status;
      if (i >= tries - 1 || (s && s < 500 && s !== 409)) throw err;
      await sleep(1000 * (i + 1));
    }
  }
}

// uploads one file in pieces; onProgress(0..1, phase) where phase is "uploading" | "storing"
export async function chunkedUpload({ target, targetId, file, onProgress }) {
  if (file.size > MAX_UPLOAD) throw new Error("each file must be under 500 MB");
  const { data: init } = await api.post("/uploads/init", { target, target_id: targetId, name: file.name, size: file.size, content_type: file.type || "application/octet-stream" });
  const size = init.chunk_size;
  let offset = 0;
  while (offset < file.size) {
    const chunk = file.slice(offset, offset + size);
    const { data } = await withRetry(() => api.put(`/uploads/${init.id}/chunk?offset=${offset}`, chunk, { headers: { "Content-Type": "application/octet-stream" } }));
    offset = data.received;
    onProgress?.(offset / file.size, "uploading");
  }
  await withRetry(() => api.post(`/uploads/${init.id}/complete`));
  onProgress?.(1, "storing");
  const giveUp = Date.now() + 15 * 60 * 1000;
  while (Date.now() < giveUp) {
    await sleep(2000);
    const { data } = await withRetry(() => api.get(`/uploads/${init.id}`));
    if (data.status === "done") return data.file;
    if (data.status === "error") throw new Error(data.error || "upload failed");
  }
  throw new Error("saving took too long, try again");
}

export const uploadError = (err) => err.response?.data?.detail || err.message || "upload failed";
